import { showToast } from '@veem/ui'
import { ApiError, api } from '../../lib/api.ts'
import { appendPickedFile } from '../../lib/file-reference.ts'
import { copySnapshot } from '../../lib/snapshot-value.ts'
import { hydrateData } from '../../prototype/data/hydration.ts'
import { type ProtoState, proto } from '../../prototype/state/store.ts'

export { createFinanceFeedback } from './feedback.ts'

let refreshFailed = false
export const financeSuccess = (message: string) => {
  showToast(refreshFailed ? `${message}. Оновіть сторінку, щоб побачити збережені зміни.` : message)
  refreshFailed = false
}

export const refreshFinance = async () => {
  const snapshot = copySnapshot(
    await api<{ data: Record<string, unknown>; state: Partial<ProtoState> }>('/snapshot'),
  )
  hydrateData(snapshot.data)
  proto.hydrate(snapshot.state)
}
export const financeMutation = async <T>(path: string, body: unknown, method = 'PATCH') => {
  refreshFailed = false
  const result = await api<T>(path, { method, body: JSON.stringify(body) })
  try {
    await refreshFinance()
  } catch {
    refreshFailed = true
  }
  return result
}
export const uploadFinanceFile = async (
  path: string,
  version: number,
  file: File,
  entityType?: string,
) => {
  if (!file.size) throw new Error('Оберіть непорожній файл')
  refreshFailed = false
  const body = new FormData()
  body.set('version', String(version))
  await appendPickedFile(body, 'file', file)
  if (entityType) body.set('entityType', entityType)
  let response: Response
  try {
    response = await fetch(`/api${path}`, { method: 'POST', body, credentials: 'include' })
  } catch {
    throw new ApiError('Немає зв’язку із сервером. Спробуйте ще раз.', 0, 'NETWORK_ERROR')
  }
  let result: {
    ok: boolean
    data?: { id: string; version: number; url: string }
    error?: { message?: string; code?: string }
  }
  try {
    result = await response.json()
  } catch {
    throw new ApiError(
      'Сервер тимчасово недоступний. Спробуйте ще раз.',
      response.status,
      'INVALID_RESPONSE',
    )
  }
  if (!response.ok || !result.ok)
    throw new ApiError(
      result.error?.message ?? 'Не вдалося завантажити файл',
      response.status,
      result.error?.code ?? 'UPLOAD_ERROR',
    )
  try {
    await refreshFinance()
  } catch {
    refreshFailed = true
  }
  return result.data as { id: string; version: number; url: string }
}
export const financeVersion = (value: unknown) => {
  const version = (value as { version?: number } | undefined)?.version
  if (!version) throw new Error('Оновіть дані перед збереженням')
  return version
}
